/**
 * Constantes de animación.
 * Ver docs/SPEC-IMPLEMENTACION.md §10.5.
 */

/** Duraciones de las transiciones principales (ms). */
export const DURACIONES = {
  sol: 4000,
  musica: 1500,
  luciernagas: 2000,
  girasoles: 1800,
  amanecer: 6000,
  carta: 1500,
  reset: 300,
} as const;

/** Easings usados por GSAP. */
export const EASINGS = {
  suave: 'power2.inOut',
  entrada: 'power2.out',
  salida: 'power2.in',
  rebote: 'back.out(1.7)',
  elástico: 'elastic.out(1, 0.5)',
} as const;
